import React, { useState } from 'react';

import { format } from 'date-fns';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';

export const CustomerDate =({dateSelected, setDateSelected})=> {
  return (
    <DayPicker
      mode="single"
      selected={dateSelected}
      onSelect={setDateSelected}
    />
  );
}